/* eslint-disable react/jsx-curly-newline */
import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'primereact/tooltip';
import PropTypes from 'prop-types';
import { useRef } from 'react';
import { formatFileNameProduct } from 'utils/func';

import { PRODUCT_TYPE } from 'constant/summary-report.constant';
import SoftProductDialog from '../SoftProductDialog';

export default function SoftProductTable({
  disabled,
  control,
  projectCode,
  handleDownloadFile,
  setProductFilesDelete,
  softProducts,
}) {
  // #region Data
  const { t } = useTranslation();
  const softProductRef = useRef();

  const { fields, insert, remove, update } = useFieldArray({
    control,
    name: 'researchResult.softProducts',
    keyName: 'customId',
  });
  // #endregion Data
  return (
    <>
      <h4 className="mt-2">
        {t('projectProposal.researchResult.productAndResearchResultDes.softProduct.label')}
      </h4>

      {softProducts?.length > 0 && (
        <div className="form-table my-2">
          <table className="mb-2">
            <thead>
              <tr>
                <th className="text-center" style={{ minWidth: 50, width: 50 }}>
                  {t('formLayout.numericalOrder')}
                </th>
                <th className="text-center" style={{ minWidth: 220, width: 340 }}>
                  {t('submitDocument.product.productDetail.name')}
                </th>
                <th className="text-center" style={{ minWidth: 220, width: 340 }}>
                  {t('submitDocument.product.productDetail.evaluationCriteria')}
                </th>
                <th className="text-center" style={{ minWidth: 220, width: 340 }}>
                  {t('submitDocument.product.productDetail.note')}
                </th>
              </tr>
            </thead>
            <tbody>
              {softProducts?.map((item, index) => (
                <tr key={item.id}>
                  <td className="text-center">{index + 1}</td>
                  <td>{item?.name}</td>
                  <td>{item?.evaluativeCriteria}</td>
                  <td>{item?.note}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <p>({t('projectProposal.researchResult.productAndResearchResultDes.softProduct.note')})</p>

      <div className="form-table">
        <table className="mb-2">
          <thead>
            <tr>
              <th className="text-center" style={{ minWidth: 50, width: 50 }}>
                {t('formLayout.numericalOrder')}
              </th>
              <th className="text-center" style={{ minWidth: 220, width: 340 }}>
                {t('submitDocument.product.productDetail.name')}
              </th>
              <th className="text-center" style={{ minWidth: 220, width: 340 }}>
                {t('submitDocument.product.productDetail.evaluationCriteria')}
              </th>
              <th className="text-center" style={{ minWidth: 220, width: 340 }}>
                {t('submitDocument.product.productDetail.note')}
              </th>
              <th className="text-center" style={{ minWidth: 200, width: 260 }}>
                {t('r05.b.b2.table.proof')}
              </th>
              {!disabled && (
                <th className="text-center float" style={{ minWidth: 80, width: 80 }}>
                  {t('projectProposal.action')}
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {fields?.map((item, index) => (
              <tr key={item.id}>
                <td className="text-center">{index + 1}</td>
                <td>{item?.productDetail?.name}</td>
                <td>{item?.productDetail?.evaluativeCriteria}</td>
                <td>{item?.productDetail?.note}</td>
                {/* <td
                  dangerouslySetInnerHTML={{ __html: getProductDetail(t, item?.productDetail) }}
                /> */}
                <td>
                  {!item?.file?.name ? (
                    item?.fileUrl && (
                      <span
                        className="p-button p-button-text p-button-sm mt-1 p-0"
                        onClick={() =>
                          handleDownloadFile(
                            item?.fileUrl,
                            formatFileNameProduct(
                              item?.fileUrl || '',
                              projectCode,
                              PRODUCT_TYPE.SOFT_PRODUCT.short,
                              index + 1
                            )
                          )
                        }
                      >
                        <i className="pi pi-file-pdf text-red-500 text-xl" />{' '}
                        <span className="text-blue-500 underline font-italic ml-1">
                          {formatFileNameProduct(
                            item?.fileUrl || '',
                            projectCode,
                            PRODUCT_TYPE.SOFT_PRODUCT.short,
                            index + 1
                          )}
                        </span>
                      </span>
                    )
                  ) : (
                    <span>
                      {formatFileNameProduct(
                        item?.file?.name || '',
                        projectCode,
                        PRODUCT_TYPE.SOFT_PRODUCT.short,
                        index + 1
                      )}
                    </span>
                  )}
                </td>
                {!disabled && (
                  <td className="float text-center p-0">
                    <div className="">
                      <i
                        onClick={() => {
                          softProductRef.current.open({
                            index,
                            projectCode,
                            value: fields[index],
                            update,
                            type: 'UPDATE',
                          });
                        }}
                        className="edit-icon pi pi-pencil text-primary cursor-pointer mt-1"
                        data-pr-tooltip={t('formLayout.action.edit')}
                        data-pr-position="left"
                      />
                      <Tooltip target=".edit-icon" />
                    </div>

                    <i
                      onClick={() => {
                        if (item?.id) {
                          setProductFilesDelete((prev) => [...prev, item.id]);
                        }
                        remove(index);
                      }}
                      className="remove-icon pi pi-times text-red-700 cursor-pointer mb-1"
                      data-pr-tooltip={t('formLayout.action.remove')}
                      data-pr-position="left"
                    />
                    <Tooltip target=".remove-icon" />
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
        {!disabled && (
          <div className="flex justify-content-center mt-2">
            <i
              onClick={() => {
                softProductRef.current.open({
                  projectCode,
                  index: fields?.length ?? 0,
                  // value: defaultValues.hardProduct,
                  insert,
                  type: 'INSERT',
                });
              }}
              className="add-hard-product pi pi-plus text-primary cursor-pointer bg-primary p-1 border-circle"
              data-pr-tooltip={t('formLayout.action.add')}
              data-pr-position="left"
            />
            <Tooltip target=".add-hard-product" />
          </div>
        )}
      </div>
      <SoftProductDialog ref={softProductRef} handleDownloadFile={handleDownloadFile} />
    </>
  );
}

SoftProductTable.propTypes = {
  disabled: PropTypes.bool,
  control: PropTypes.shape({}).isRequired,
  projectCode: PropTypes.string.isRequired,
  handleDownloadFile: PropTypes.func,
  setProductFilesDelete: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  softProducts: PropTypes.array,
};

SoftProductTable.defaultProps = {
  disabled: false,
  handleDownloadFile: () => null,
  setProductFilesDelete: () => null,
  softProducts: [],
};
